class Ajax {
	static xHttp() {
		if (window.XMLHttpRequest) {
			return new XMLHttpRequest;
		} else {
			return new ActiveXObject("Microsoft.XMLHTTP");
		}
	}
    static g() {
        
    }
	static p(){
		
	}
}